import { SUPPORTED_LANGUAGES } from "i18n";
import { changeLanguage } from "i18n";
import { FC, memo, useEffect, useState } from "react";
import { composeRouteUrl } from "router";

import { IURLSearchParams } from "@/browser";
import { useOnLanguageChange } from "@/hooks/Translations";
import { IRoute } from "@/router/types";
import { useRouter } from "@/router/useRouter";

interface ILanguageRouteHandler {
  route: IRoute;
}

export const LanguageRouteHandler: FC<ILanguageRouteHandler> = memo(({ route }) => {
  const [loaded, setLoaded] = useState(false);
  const currentLang = useOnLanguageChange();
  const {
    matchParams: { lng, ...rest },
    replace,
    searchParams,
    state,
  } = useRouter();

  useEffect(() => {
    if (lng && lng !== currentLang && SUPPORTED_LANGUAGES.includes(lng)) {
      changeLanguage(lng);
    } else {
      const newRoute = composeRouteUrl(route.path, { ...rest, lng: currentLang }, searchParams as IURLSearchParams);
      replace(newRoute, state);
    }
    setLoaded(true);
  }, []);

  useEffect(() => {
    if (loaded) {
      const newRoute = composeRouteUrl(route.path, { ...rest, lng: currentLang }, searchParams as IURLSearchParams);
      replace(newRoute, state);

      // refresh page so that data can be refetched from BE with a new lang header
      window.location.reload();
    }
  }, [currentLang]);

  return null;
});
